import i18n from "../localizations";

export default class TeamNameGenerator {
  _firstLetterCode = 'A'.charCodeAt(0);
  _lastLetterCode = 'Z'.charCodeAt(0);
  _counter = 0;

  getName() {
    return `${i18n.t("tableColumns.team")} ${this._getNextLetter()}`;
  }

  goToPreviousName() {
    this._counter--;
  }
  
  _getNextLetter() {
    // If counter is greater than range of letters, method will return number - not letter
    if (this._counter > this._lastLetterCode - this._firstLetterCode) {
      return this._counter++ - (this._lastLetterCode - this._firstLetterCode);
    }

    return String.fromCharCode(this._firstLetterCode + this._counter++);
  }
}